export default "__VITE_ASSET__ee2e8795__"